import React from 'react'
import ContentCreator from '../../../components/ContentCreator/ContentCreator';
import TanStackTable from '../../../components/Table/TanStackTable/TanStackTable';
// import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import useAcademicSubscription from '../../../hooks/Academic/Subscription/useAcademicSubscription';
import AcademicSubscriptionForm from './AcademicSubscriptionForm';

export default function AcademicSubscriptionsContainer() {

   const { 
      columns,
      displayForm,
      editSubscription,
      handleSubmit,
      initialValuesEdit,
      loading,
      setDisplayForm,
      setInitialValuesEdit,
      subscriptionData,
      onCreateInitialValues,

      // setDeleteModalOpen,
      // setSelectedSubscriptionId,
      // deleteSubscriptionPlan, 
      // deleteModalOpen,
   } = useAcademicSubscription()

   return (
      <section className='AcademicContent-main-container'>

         {displayForm && (
            <ContentCreator
               title={initialValuesEdit ? "Editar plan" : "Crear plan"}
               submitFunc={(values) => handleSubmit(values)}
               onCancel={() => {
                  setDisplayForm(false);
                  setInitialValuesEdit(null);
               }}
               initialValues={initialValuesEdit ?? onCreateInitialValues}
               renderPreview={(_form) => (
                  <></>
               )}
               renderForm={(_form) => (
                  <AcademicSubscriptionForm form={_form.form} loading={loading} />
               )}
            />
         )}
         <TanStackTable
            data={subscriptionData}
            columns={columns}
            editFunc={editSubscription}
            // onDelete={deleteSubscriptionPlan}
            displayForm={displayForm}
            addButtonFunc={() => {
               setDisplayForm(!displayForm);
               if (displayForm) setInitialValuesEdit(null);
            }}
         />

         {/* <DeleteConfirmationModal
            opened={deleteModalOpen}
            loading={loading}
            onClose={() => {
               setDeleteModalOpen(false)
               setSelectedSubscriptionId(null)
            }}
            onCancel={() => {
               setDeleteModalOpen(false)
               setSelectedSubscriptionId(null)
            }}
            onConfirm={deleteSubscriptionPlan}
         /> */}

      </section>
   )
}
